"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERY = exports.LABEL_HEIGHT = exports.CHIP_HEIGHT = void 0;
const QUERY = exports.QUERY = 'query';
const CHIP_HEIGHT = exports.CHIP_HEIGHT = 35;
const LABEL_HEIGHT = exports.LABEL_HEIGHT = 21;
